import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

// Generic single-field write to a unit's Firestore doc, shared by every unit
// property (smart actions, scheduledWF, postAssemblyCalibration,
// parameters, ...) instead of one bespoke function per field.
export const updateUnitField = async (unitId, fieldName, value) => {
  try {
    const unitDocRef = doc(db, 'units', unitId);
    await updateDoc(unitDocRef, { [fieldName]: value });
    return { success: true, [fieldName]: value };
  } catch (error) {
    console.error(`Error updating ${fieldName}:`, error);
    throw error;
  }
};
